import { useCookies, withCookies } from "react-cookie"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { useAuthCheck } from "../util/utils"
import { useEffect, useState } from "react"
import NotificationList from "./NotificationList"
import { useNavigate } from "react-router-dom"
import PendingFollowRequests from "../components/PendingFollowRequests"

const NotificationComponent = ({ api }) => {

    useAuthCheck()

    const navigate = useNavigate()
    const [cookies] = useCookies()
    const [unreadCount, setUnreadCount] = useState()
    const [notifications, setNotifications] = useState([])
    const [isPrivate, setIsPrivate] = useState(true)

    const fetchNotifications = async () => {
        try {
            const resp = await api().fetchNotifications(cookies.token)
            if (resp.status === 200) {
                setNotifications(resp.data)
            }
        } catch (e) {

        }
    }

    const fetchMe = async () => {
        try {
            let resp = await api().getMe(cookies.token)
            if (resp.status === 200) {
                setIsPrivate((prev) => (
                    resp.data.isPrivate
                ));
            }
        } catch (e) { }
    }

    const markAllAsRead = async () => {
        if (unreadCount > 0) {
            try {
                const res = await api().markNotificationsAsRead(cookies.token, notifications.filter((n) => !n.read).map((n) => n._id).join('&id='))
                if (res.status === 200) {
                    const readNotificaitons = notifications.map((n) => ({
                        ...n,
                        read: true,
                    }))
                    setNotifications(readNotificaitons)
                }
            } catch (e) {

            }
        } else {
            // setIsOpen(false)
        }
    }

    const markAsReadAndNavigate = async (notif) => {
        if (!notif.read) {
            try {
                await api().markNotificationsAsRead(cookies.token, notif._id)
            } catch (e) {

            }
        }
        navigate(`/user/${notif.actionableUsername}`)
    }

    useEffect(() => {
        if (cookies.token) {
            fetchNotifications()
        }
    }, [cookies.token])

    useEffect(() => {
            if (cookies.token) fetchMe()
        }, [cookies.token])

    useEffect(() => {
        setUnreadCount(notifications.filter((notif) => !notif.read).length)
    }, [notifications])



    return (
        <div>
            <Header api={api} unreadCount={unreadCount} />
            <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen flex flex-col pt-20 items-center py-8">
                <div className="bg-white shadow-lg rounded-lg w-full max-w-md p-6">
                    <div className="flex justify-between items-center mb-3">
                        <h2 className="text-2xl  font-bold">Notifications</h2>
                        {unreadCount > 0 && <button
                            onClick={markAllAsRead}
                            className="text-sm text-green-600 hover:underline"
                        >
                            Mark all as read
                        </button>}
                    </div>
                    {isPrivate &&
                    <PendingFollowRequests api={api}/>
                    }
                    <NotificationList notifications={notifications} onClick={markAsReadAndNavigate} />
                </div>
            </div>
            <Footer />

        </div>
    )
}

const Notifications = withCookies(({ api }) => (
    <NotificationComponent api={api} />
))

export default Notifications